// extracted by mini-css-extract-plugin
module.exports = {"quickImage":"QuickLink_quickImage__Zkjyp"};